export const COMMENTS_RELATIONSHIPS = {
  action: 'action',
  alert: 'alert',
  auditTemplateCriterion: 'audit_template_criteria',
  auditCriterion: 'audit_criteria',
  kpiCard: 'kpi_card',
  taskManagerAssessment: 'task_manager_assessment',
  dailyRoundAssessment: 'daily_round_assessment',
  faceToFaceAssessment: 'face_to_face_assessment',
  gembaWalkAssessment: 'gemba_walk_assessment',
  improvementIdea: 'improvement_idea',
  okFirstPartAssessment: 'ofp_assessment',
  standardSevenWaste: 'standard_seven_waste',
}
